import React from "react";
import "./MinimalFooterComponent.scss";
import { IMinimalFooterProps } from "./MinimalFooterComponent.types";
import { Row } from "antd";

const MinimalFooterComponent = ({ classname }: IMinimalFooterProps) => {
  return (
      <div className={`MinimalFooterComponent`}>
          <Row justify="center">
            <img
              className={"MinimalFooterComponent_autofactLogo_default"}
              src={"https://static.retail.autofact.cl/img/logo/logo-autofact-blanco.svg"}
              alt={"AutofactLogo"}
            />
          </Row>
      </div>
  );
};

export default MinimalFooterComponent;
